import { axios } from "@/utils/request";

// 开关 paramKey  uvCode
export function getFlag(params = {}) {
  return axios({
    url: "/welcome/publish/moblie/login/getParamStatus",
    method: "get",
    params: params,
  });
}

// 获取行政区划
export function getCity(params = {}) {
  return axios({
    url: "/welcome/publish/admin/region/list/all",
    method: "get",
    data: params,
  });
}

// 批量获取字典  types   uvCode
export function getDicAll(params = {}) {
  return axios({
    url: "/welcome/publish/admin/dict/type/listin",
    method: "get",
    params: params,
  });
}

// 保存操作记录
export function saveLog(params = {}) {
  return axios({
    url: "/welcome/publish/stuLog/save",
    method: "post",
    data: params,
  });
}
